// extracted by mini-css-extract-plugin
export default {"root":"Version_root__dC1th","suffix":"Version_suffix__dGzkE"};